import { Route, Switch } from "react-router-dom";

import Layout from "@/containers/Layout";
import { ROUTES } from "@/routes_new";

import { MentionsViewInner } from "../MentionsView";
import Empty from "./empty";

const SavedSearchView: React.FunctionComponent = () => {
  return (
    <Layout>
      <Switch>
        <Route path={ROUTES.SAVED_SEARCHES_DETAIL_ORGID}>
          <MentionsViewInner url={ROUTES.SAVED_SEARCHES_DETAIL_ORGID} />
        </Route>
        <Route path={ROUTES.SAVED_SEARCHES_ORGID} component={Empty} />
      </Switch>
    </Layout>
  );
};

export default SavedSearchView;
